<template>

    <v-data-table
        :items="logs"         
        hide-default-footer        
    >

        <template
        slot="headerCell"
        slot-scope="{ header }"
        >
        <span
            class="subheading font-weight-light text-success text--darken-3"
            v-text="header.text"
        />
        </template>
        <template
        v-slot:item="props"
        >
        <v-slide-x-transition>
        <tr class="selectorRow">
            <!-- <td v-for="(n,index) in headers" :key="index">{{ props.item[n.value] }}</td> -->

            <td>
            <v-avatar size="38" small>
                <v-icon v-text="getIcon(props.item.category)" ></v-icon>
            </v-avatar>
            </td>
            <td>
                <span v-if="logType=='form'" class="body-2">{{props.item.log}}</span>
                <span v-if="logType!='form'" class="body-2">{{props.item.title}}</span><br>
                <span class="caption">{{props.item.time | moment}}</span>
            </td>
        </tr>
        </v-slide-x-transition>

        <dialog-delete></dialog-delete>
        
        </template>

    </v-data-table>
    

</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  props: {
    logType: {
      type: String,
      default: undefined
    },
    reference: {
      type: String,
      default: undefined
    }
  },
  filters: {
    moment(date) {
      moment.locale("nl");
      return moment(date).format("LLL");
    }
  },
  data() {
    return {
      interval: null,
      logs: []
    };
  },
  computed: {
    log() {
      return this.$store.state.log;
    }
  },
  methods: {
    timingStatus() {
      this.interval = setInterval(() => {
        this.getLogDetails();
      }, 10000);
    },
    getIcon(cat) {
      if (cat == "DO") {
        return "$vuetify.icons.document";
      } else if (cat == "ES") {
        return "$vuetify.icons.estate";
      } else if (cat == "CO") {
        return "$vuetify.icons.company";
      } else if (cat == "NO") {
        return "$vuetify.icons.notification";
      } else if (cat == "AC") {
        return "$vuetify.icons.activity";
      } else if (cat == "EM") {
        return "$vuetify.icons.email";
      } else if (cat == "ER") {
        return "$vuetify.icons.error";
      } else if (cat == "RD") {
        return "$vuetify.icons.read";
      } else if (cat == "SI") {
        return "$vuetify.icons.signed";
      } else if (cat == "ST") {
        return "$vuetify.icons.start";
      } else if (cat == "CP") {
        return "$vuetify.icons.completed";
      } else if (cat == "FI") {
        return "$vuetify.icons.filled";
      }
    },
    getLogDetails() {
      if (this.logType == "form") {
        this.$store.dispatch("getFormLog", {
          reference: this.reference
        });
      } else {
        this.$store.dispatch("getContractLog");
      }
    }
  },
  created() {
    this.timingStatus();
    this.getLogDetails();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.$store.state.log = [];
  },
  watch: {
    log() {
      if (this.log.length > this.logs.length) {
        this.logs = this.log;
      }
    }
  }
};
</script>
